import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { Simulator } from '../../../../common/simulator/simulator';
import { tabs, tabsTablet, tabsDesktop } from './items';
import { SimulatorTabProps } from '../../../../common/simulator/simulator.models';

export const Aom1dSimulator = (): JSX.Element => {
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));
  const tabItems = useMemo((): SimulatorTabProps[] => {
    if (isMobile) {
      return tabs;
    } else if (isDesktop) {
      return tabsDesktop;
    } else {
      return tabsTablet;
    }
  }, [isDesktop, isMobile]);

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: 'simulator.title' })}
        </title>
      </Helmet>
      <Simulator tabs={tabItems} hint="simulator.aom1d.hint" />
    </>
  );
};
